var render = function render(){var _vm=this,_c=_vm._self._c;return _c('navBar',{attrs:{"title":"Ares - Purchase partners","home":true,"type":"pp"}})
}
var staticRenderFns = []

export { render, staticRenderFns }